import React, { useEffect, useState, useCallback } from 'react'
import { getProfitMargin } from '../../../../actions/restaurantAction'
import { useSelector } from 'react-redux'
import PriceHeader from '../customs/PriceHeader'
import BottomTabNav from "../../customs/BottomTabNav"
import SinglePriceInput from '../customs/SinglePriceInput'

export default function EditPlans(props) {
  const [isDelivery, setIsDelivery] = useState(false)
  const [profits, setProfits] = useState([])
  const [category, setCategory] = useState("Lunch")
  const [pricePlans, setPricePlans] = useState([])
  const { restaurant } = useSelector(state => state)


  useEffect(() => {
    async function getMargin() {
      const profit = await getProfitMargin()
      setProfits(profit)
    }
    let componentMount = true
    if (componentMount) {
      getMargin()
    }
    return () => {
      componentMount = false
    }
  }, [])

  useEffect(() => {
    let componentMount = true
    if (componentMount) {
      const { price_plans } = restaurant
      setPricePlans(price_plans)
    }
    return () => {
      componentMount = false
    }
  }, [restaurant])


  const isDeliveryChange = (value) => {
    setIsDelivery(value)
  }
  const handleCategory = (value) => {
    setCategory(value)
  }

  const onChangePrice = useCallback((key, value) => {
    setPricePlans((prevPlans) => {
      const updatedPlans = prevPlans.map((plan) => {
        if (plan.category === category) {
          return {
            ...plan,
            plans: [...plan.plans, value],
          };
        } else {
          return plan;
        }
      });
      return updatedPlans;
    });
  }, [category, setPricePlans]);

  const handleContinue = () => {
    console.log('====================================');
    console.log(pricePlans);
    console.log('====================================');
  }
  return (
    <>
      <div className="ibox-content px-0">
        <PriceHeader
          handler={isDeliveryChange}
          setCategory={handleCategory}
          category={category} />
        <SinglePriceInput
          isDelivery={isDelivery}
          onChangePrice={onChangePrice}
          plans={profits}
          category={category} />
      </div>
      <BottomTabNav
        currentStep={4}
        props={props}
        handler={handleContinue}
        data={pricePlans} />
    </>
  )
}
